import { render, staticRenderFns } from "./userMessage.vue?vue&type=template&id=2bfe980f&scoped=true&"
import script from "./userMessage.vue?vue&type=script&lang=js&"
export * from "./userMessage.vue?vue&type=script&lang=js&"
import style0 from "./userMessage.vue?vue&type=style&index=0&id=2bfe980f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe980f",
  null
  
)

export default component.exports